import svg4everybody from 'svg4everybody';

const init = () => {
  svg4everybody();
};

if(typeof Turbolinks !== 'undefined') {
  document.addEventListener('turbolinks:load', init);
}
else {
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
}
